<template>
  <span>
    <legal-user-account
      v-if="current_user.user_type == user_types.LEGAL"
      :wizard="wizard"
      :user="user"
    ></legal-user-account>
    <form v-else @submit.prevent="update" id="profile_form">
      <div class="d-flex align-items-center px-3 mb-4">
        <div>
          <span class="h4">مشخصات فردی</span>
        </div>
      </div>
      <div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="username">نام کاربری</label>
            <input
              type="text"
              id="username"
              class="form-control text-left"
              name="username"
              v-model="user.username"
            />
            <div
              :class="['text-danger', (!is_username_valid() && has_submit_attempt) ? '' : 'd-none']"
            >
              <small v-text="error_msg.username"></small>
            </div>
          </div>
          <div class="form-group w-50 px-3">
            <label for="email">ایمیل</label>
            <input
              type="email"
              id="email"
              name="email"
              class="form-control text-left"
              v-model="user.email"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="first_name">نام</label>
            <input
              type="text"
              id="first_name"
              class="form-control"
              name="first_name"
              v-model="user.first_name"
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="first_name_en"
              >نام <small style="color: #bbb">انگلیسی</small>
            </label>
            <input
              type="text"
              id="first_name_en"
              name="first_name_en"
              class="form-control text-left"
              v-model="user.first_name_en"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="last_name">نام خانوادگی</label>
            <input
              type="text"
              id="last_name"
              class="form-control"
              name="last_name"
              v-model="user.last_name"
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="last_name_en"
              >نام خانوادگی <small style="color: #bbb">انگلیسی</small>
            </label>
            <input
              type="text"
              id="last_name_en"
              name="last_name_en"
              class="form-control text-left"
              v-model="user.last_name_en"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="father_name">نام پدر</label>
            <input
              type="text"
              id="father_name"
              name="father_name"
              class="form-control"
              v-model="user.father_name"
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="father_name_en"
              >نام پدر <small style="color: #bbb">انگلیسی</small>
            </label>
            <input
              type="text"
              id="father_name_en"
              name="father_name_en"
              class="form-control text-left"
              v-model="user.father_name_en"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="birth_date">تاریخ تولد</label>
            <datePicker
              color="#00c1a4"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="dddd jDD jMMMM jYYYY"
              input-class="form-control"
              id="birth_date"
              name="birth_date"
              v-model="user.birth_date"
              type="date"
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="id_number">کد ملی</label>
            <input
              type="text"
              id="national_code"
              name="national_code"
              class="form-control text-left"
              v-model="user.national_code"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="mobile">شماره موبایل</label>
            <input
              type="text"
              id="mobile"
              name="phone"
              class="form-control text-left"
              :value="user.phone"
              disabled
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="telephone">تلفن ثابت</label>
            <input
              type="text"
              dir="ltr"
              id="telephone"
              name="telephone"
              class="form-control text-left"
              v-model="user.telephone"
            />
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="form-group w-50 px-3">
            <label for="password">رمزعبور</label>
            <input
                type="password"
                id="password"
                name="password"
                class="form-control text-left"
                v-model="user.password"
            />
          </div>
          <div class="form-group w-50 px-3">
            <label for="confirmed_password">تکرار رمز عبور</label>
            <input
                type="password"
                dir="ltr"
                id="confirmed_password"
                name="confirmed_password"
                class="form-control text-left"
                v-model="user.confirmed_password"
            />
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center px-3 mt-4">
        <div class="mr-auto">
          <button
            type="submit"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            id="submit_btn"
            :disabled="form_submit_loading"
          >
            <span v-if="form_submit_loading">
              <span class="pl-2">در حال انجام</span>
              <span
                class="spinner-border spinner-border-sm p-2"
                role="status"
              ></span>
            </span>
            <span v-else>مرحله بعد</span>
          </button>
        </div>
      </div>
    </form>
  </span>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import { userService } from "@/common/api.service";
import Inputmask from "inputmask";
import { i18n } from "@/plugins/i18n";
import { userTypes } from "@/constants/userTypes";
import LegalUserAccount from "./legal-user-account";
import p2f from "persian-to-pinglish";
import { getFinglish } from "@/constants/names";

export default {
  name: "account",
  components: {
    LegalUserAccount,
  },
  props: {
    wizard: Object,
  },
  data() {
    return {
      has_submit_attempt: false,
      user_types: userTypes,
      user: this.$store.state.user.current_user,
      form_submit_loading: false,
      error_msg: {
        username: "",
      },
    };
  },
  computed: {
    ...mapState("user", {
      status: (state) => state.status,
    }),
    ...mapGetters("user", ["profile_completed", "current_user"]),
    user_first_name() {
      return this.user.first_name;
    },
    user_last_name() {
      return this.user.last_name;
    },
    user_father_name() {
      return this.user.father_name;
    },
  },
  watch: {
    status() {
      this.user = this.$store.state.user.current_user;
    },
    user_first_name() {
      let finglish = getFinglish(this.user.first_name);

      if (finglish) {
        this.user.first_name_en = finglish;
      } else {
        this.user.first_name_en = p2f(this.user.first_name);
      }
    },
    user_last_name() {
      let finglish = getFinglish(this.user.last_name);

      if (finglish) {
        this.user.last_name_en = finglish;
      } else {
        this.user.last_name_en = p2f(this.user.last_name);
      }
    },
    user_father_name() {
      let finglish = getFinglish(this.user.father_name);

      if (finglish) {
        this.user.father_name_en = finglish;
      } else {
        this.user.father_name_en = p2f(this.user.father_name);
      }
    },
  },
  mounted() {
    const self = this
    $.validator.addMethod('confirm', function (value) {
      return value === self.user.password;
    }, 'رمزعبور یکسان نمی باشد.');

    this.$nextTick(function () {
      this.initialSetup();
    });
  },
  methods: {
    is_username_valid() {
      if (this.user.username == null || this.user.username == "") {
        this.error_msg.username = "تکمیل این فیلد اجباری است.";
        return false;
      } 
      
      if (this.user.username.length < 5) {
        this.error_msg.username = "نام کاربری باید بیشتراز پنج کاراکتر باشد.";
        return false;
      }
      
      if(!(this.user.username.match("^[a-zA-Z0-9]{5,15}$"))) {
        this.error_msg.username = "نام کاربری باید شامل حروف انگلیسی و اعداد باشد";
        return false;
      }

      return true;
    },
    initialSetup() {
      setTimeout(() => {
        document.getElementById("telephone") &&
          Inputmask("099-99999999").mask(document.getElementById("telephone"));
      }, 1000);
    },
    update(e) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      this.has_submit_attempt = true;

      if (!this.is_username_valid()) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      }

      form.validate({
        ignore: ":hidden",

        rules: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          first_name_en: {
            required: true,
          },
          last_name_en: {
            required: true,
          },
          father_name: {
            required: true,
          },
          father_name_en: {
            required: true,
          },
          national_code: {
            required: true,
          },
          birth_date: {
            required: true,
          },
          telephone: {
            required: true,
          },
          phone: {
            required: true,
          },
          email: {
            required: true,
          },
          password: {
            required: true,
          },
          confirmed_password: {
            required: true,
            confirm: true
          },
        },
      });

      if (!form.valid()) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      }

      if (!this.validateSocialId(this.user.national_code)) {
        form.validate().showErrors({
          national_code: i18n.t("validation.invalid_national_code"),
        });
        return;
      }

      let params = {
        username: this.user.username,
        first_name: this.user.first_name,
        first_name_en: this.user.first_name_en,
        last_name: this.user.last_name,
        last_name_en: this.user.last_name_en,
        father_name: this.user.father_name,
        father_name_en: this.user.father_name_en,
        national_code: this.user.national_code,
        birth_date: this.user.birth_date,
        phone: this.user.phone,
        telephone: this.user.telephone,
        email: this.user.email,
        password: this.user.password,
        confirmed_password: this.user.confirmed_password,
      };

      this.form_submit_loading = true;
      userService
        .update(params)
        .then((response) => {
          this.$store.commit("user/success", response.data.data);
          this.wizard.current_step = 2;
        })
        .catch(({ response }) => {
          if (response.data) {
            form.validate().showErrors(response.data.data);
          } else {
            this.showMsg(form, "danger", response.data.message);
          }
        })
        .finally(() => {
          this.form_submit_loading = false;
        });
    },
    validateSocialId(social_id) {
      var L = social_id.length;

      if (L < 8 || parseInt(social_id, 10) == 0) return false;
      social_id = ("0000" + social_id).substr(L + 4 - 10);
      if (parseInt(social_id.substr(3, 6), 10) == 0) return false;
      var c = parseInt(social_id.substr(9, 1), 10);
      var s = 0;
      for (var i = 0; i < 9; i++)
        s += parseInt(social_id.substr(i, 1), 10) * (10 - i);
      s = s % 11;
      return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
    },
  },
};
</script>

<style scoped>
</style>